import * as THREE from 'three'
import Transition from './Transition.js'

export default class Camera
{
    constructor()
    {
      this.experience = new Transition()
      this.sizes = this.experience.sizes
      this.scene = this.experience.scene
      this.canvas = this.experience.canvas

      this.setInstance()
    }

    setInstance()
    {
        this.instance = new THREE.OrthographicCamera( - 1, 1, 1, - 1, 0, 5 );
        this.instance.position.set(0, -1, 1)
        this.scene.add(this.instance)
        this.instance.aspect = this.sizes.width / this.sizes.height
        this.instance.updateProjectionMatrix()
    }

    resize()
    {
        this.instance.aspect = this.sizes.width / this.sizes.height
        this.instance.updateProjectionMatrix()
    }

    update()
    {

    }
}